// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { MasterConstants } from './../../../common/constants/master-constants';
import { CPPLandingFilterVM } from './../../../models/CPP/CPPLandingFilterVM';
import { DashboardFilter } from './../../../models/DashboardFilter';
import { CppService } from './../../../services/cpp/cpp.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { CommonService } from './../../../services/common/common.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { MobilePDFVM } from './../../../models/CPP/MobilePDFVM';
import { CPPOrderSummaryVM } from './../../../models/CPP/CPPOrderSummaryVM';
// Service Class
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-cpp-landing',
  templateUrl: './cpp-landing.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  styleUrls: ['./cpp-landing.component.scss']
})
export class CppLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('placedCPPOrdersTable', { read: MatSort }) placedCPPOrdersSort: MatSort;
  @ViewChild('placedCPPOrdersPaginator', { read: MatPaginator }) placedCPPOrdersPaginator: MatPaginator;

  @ViewChild('draftCPPOrdersTable', { read: MatSort }) draftCPPOrdersSort: MatSort;
  @ViewChild('draftCPPOrdersPaginator', { read: MatPaginator }) draftCPPOrdersPaginator: MatPaginator;

  @ViewChild('quoteCPPOrdersTable', { read: MatSort }) quoteCPPOrdersSort: MatSort;
  @ViewChild('quoteCPPOrdersPaginator', { read: MatPaginator }) quoteCPPOrdersPaginator: MatPaginator;

  public draftCPPOrdersDataSource: MatTableDataSource<any>;
  public placedCPPOrdersDataSource: MatTableDataSource<any>;
  public quoteCPPOrdersDataSource: MatTableDataSource<any>;
  public blanketOrdersDataSource: MatTableDataSource<any>;
  public blanketDraftOrdersDateSource: MatTableDataSource<any>;
  resultant: any = [];
  draftCPPOrdersList: any = [];
  placedCPPOrdersList: any = [];
  quoteCPPOrdersList: any = [];
  quoteCPPOrdersAllList: any = [];
  uniquePlacedCPPOrdersList: any = [];
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  IsMobile = false;
  isInMobileApp = false;

  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  orderPdf: CPPOrderSummaryVM = new CPPOrderSummaryVM();
  pdfDataObject: any;
  placedCPPOrdersFooterColumns: string[] = [];
  draftCPPOrdersColumns: string[] = ['webOrderNumber', 'purchaseOrderNumber', 'accountName', 'accountNumber', 'orderCreateDate', 'contextMenu'];
  placedCPPOrdersColumns: string[] = ['webOrderNumber', 'purchaseOrderNumber', 'accountName', 'accountNumber', 'orderCreateDate', 'status', 'contextMenu'];
  quoteCPPOrdersColumns: string[] = ['quoteNumber', 'accountName', 'accountNumber', 'status', 'quoteDate', 'closeDate', 'preparedBy', 'preparedFor', 'openLines', 'contextMenu'];
  quoteCPPOrdersInnerColumns: string[] = ['orderId', 'customerPO', 'deliverTo', 'accountId', 'draftDate', 'status', 'contextMenu'];
  accountList: any;
  eAAccountList: any[] = [];
  selectedAccount: number;
  validateEvolveData: any;
  readOnlyAccess = false;
  readOnlyEarlyAdvantageAccess = false;
  isNotValid = false;
  tabNode = false;
  userMenuAccessList: any;
  accountEmail: string;
  isEvolveAccountRestriction = false;
  selectedValue: string;
  filterValueList = new Array();
  searchTypeList: string[] = [];
  fromRequestedDeliveryDateFilter: any;
  toRequestedDeliveryDateFilter: any;
  fromOrderDateFilter: any;
  toOrderDateFilter: any;
  fromQuoteDateFilter: any;
  toQuoteDateFilter: any;
  fromCloseDateFilter: any;
  cppProductItemsDataSource2: any[];
  toCloseDateFilter: any;
  productFilters: any;
  itemList: any = [];
  itemListCPP: any = [];
  filter: CPPLandingFilterVM = new CPPLandingFilterVM();
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  totalOrderCost = 0;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  errorStatusCount = 0;
  processedStatusCount = 0;
  unProcessedStatusCount = 0;
  cancelledStatusCount = 0;
  plannedStatusCount = 0;
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  processingStatusList: any = ['ORDER CREATED', 'SUBMITTED', 'CANCELLED', 'ERROR', 'SHIPPED'];
  ddlAccounts: any[] = [];
  tabIndex = 0;
  hasQuoteTabAccess = true;
  isCPPPriceAccess = false;
  openOrderCount = 0;
  closeOrderCount = 0;
  currentSelTab: number;
  isBulkItemAvailable = false;
  openStatus: string[] = ['OPEN', 'APPROVED', 'APPROVED WITH EXCEPTION'];
  closeStatus: string[] = ['CLOSED', 'REJECTED'];
  disclaimerMessage: string;
  dynamicDisclaimerMessage: string;
  subscription = new Subscription();
  isSubscriptionAccess = false;
  isPackagedItemAvailable = false;
  packagedContactName = '';
  packagedContactNumber = '';
  packagedDeliveryInst = '';

  quoteStatusList: any =
    [
      { value: 'Open', text: 'Awaiting customer approval' },
      { value: 'Approved', text: 'Accepted; may be released for fulfillment' },
      { value: 'Approved with Exception', text: 'Accepted; exceptions will be carried out during fulfillment' },
      { value: 'Rejected', text: 'Not approved by customer' },
      { value: 'Closed', text: 'Fulfillment is in process or has been completed' }
    ];// todo: need to change text

  headerQuoteStatusList: any = [{ id: 1, value: 'OPEN QUOTE ORDERS' }, { id: 2, value: 'CLOSED QUOTE ORDERS' }];
  headerQuoteStatus = 1;
  currentTab = 0;
  filter2: MobilePDFVM = new MobilePDFVM();
  baseApisuccess = false;
  isTestPdf = false;
  basePdfData: string;

  blanketOrderStatusList: any = ['SUBMITTED', 'OPEN', 'CLOSED'];
  blanketOrderDraftStatusList: any = ['DRAFT'];
  fromBlanketOrderDateFilter: any;
  toBlanketOrderDateFilter: any;
  hasBlanketTabAccess = true;
  blanketFilter: CPPLandingFilterVM = new CPPLandingFilterVM();
  hasCheckQuoteAccess = false;
  haveBannerMessage: boolean;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private cppService: CppService,
    private quoteService: QuoteOrderService,
    private blanketOrderService: BlanketOrderService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  // Page initilization code
  ngOnInit() {
    this.isInMobileApp = this.isInWebView();

    this.haveBannerMessage = false;
    this.getSeasonBanner();
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.GetDisclaimerMessage();
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
      this.isSubscriptionAccess = sessionData.isSubscriptionAccess;

      if (this.isEvolveAccountRestriction == true) {
        this.subscription.add(this.commonService.getFilterDDLData().subscribe(result => {
          this.ddlAccounts = result.accounts;
        }, error => LolLoggerService.error(error)));
      }

      this.setSearchTypeList();
      this.getShipToFacility();
      this.getItemNumbers();

      const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveAccessData) {
        this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.readOnlyEarlyAdvantageAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.EARLY_ADVANTAGE_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);

          if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
            this.isCPPPriceAccess = true;
          } else {
            this.quoteStatusList =
              [
                { value: 'Approved', text: 'Accepted; may be released for fulfillment' },
                { value: 'Approved with Exception', text: 'Accepted; exceptions will be carried out during fulfillment' },
                { value: 'Rejected', text: 'Not approved by customer' },
                { value: 'Closed', text: 'Fulfillment is in process or has been completed' }
              ];// todo: need to change text
          }
        }
      }
    }

    this.resetPageFilter();

    const menuAccessList = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
    this.subscription.add(this.quoteService.checkQuoteOrderTabAccess().subscribe(result => {
      this.hasQuoteTabAccess = result;
      if (this.commonService.checkUserRoleAccessTypeForMenu(menuAccessList, MasterConstants.FUNCTION_CODE.EARLY_ADVANTAGE_ORDER)) {
        this.subscription.add(this.blanketOrderService.checkBlanketOrderTabAccess().subscribe(result => {
          this.blanketOrdersDataSource = new MatTableDataSource([]);
          this.blanketDraftOrdersDateSource = new MatTableDataSource([]);
          this.hasBlanketTabAccess = result;
          this.subscription.add(this.commonService.currentTabIndex.subscribe(val => {
            this.currentTab = val;
            this.tabIndex = val;
          }));
          this.getCppOrders();
        }));
      }
      else {
        this.hasBlanketTabAccess = false;
        this.getCppOrders();
      }
    }));

    if (this.isMobile) {
      this.IsMobile = true;
    }
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  isInWebView(): boolean {
  const ua = navigator.userAgent || '';

  // React Native WebView
  if ((window as any).ReactNativeWebView) return true;

  // iOS WebView: AppleWebKit but NOT Safari
  const isIOS = /iPhone|iPod|iPad/i.test(ua);
  const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

  // Android WebView: look for 'wv' or no 'Chrome' version string
  const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

  return isIOSWebView || isAndroidWebView;
}
  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.tabIndex = tabChangeEvent.index;
    this.setSearchTypeList();
    this.setAccSummaryTableHeight();
    this.getItemNumbers();
    if (this.tabIndex === 2 || this.currentSelTab === 2 || this.tabIndex === 3 || this.currentSelTab === 3
      || this.tabIndex === 4 || this.currentSelTab === 4) {
      this.toastrService.info('Your filters have been cleared');
      this.clearAllFilter();
    }
    this.currentSelTab = tabChangeEvent.index;
  };

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {

    if (this.haveBannerMessage) {
      setTimeout(function () {
        const templateHeight = window.innerHeight - $('.status-bar').outerHeight() - $('.cppTopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 150;
        $('.dealertableContainer').css('max-height', templateHeight + 'px');
        $('.growertableContainer').css('max-height', templateHeight + 'px');
      }, 100);
    }
    else {
      setTimeout(function () {
        const templateHeight = window.innerHeight - $('.cppTopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 120;
        $('.dealertableContainer').css('max-height', templateHeight + 'px');
        $('.growertableContainer').css('max-height', templateHeight + 'px');
      }, 100);
    }
    
  }

  // get account list for early advantage
  getShipToFacility() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.blanketOrderService.blanketShipToList().subscribe(result => {
      this.eAAccountList = result;
      // this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getItemNumbers() {
    if ((this.tabIndex < 2 && (!this.itemListCPP || this.itemListCPP.length === 0))) {
      this.subscription.add(this.cppService.getCppParentItemNumberList().subscribe((result: any[]) => {
        this.itemListCPP = result;
      }));
    }
    if (!this.itemList || this.itemList.length === 0) {
      this.subscription.add(this.cppService.getCppItemNumberList().subscribe((result: any[]) => {
        this.itemList = result;
      }));
    }
  }


  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Get Cpp orders list
  getCppOrders() {
    this.GetCppOrdersByRetainedFilters();
    this.loaderService.setLoaderStatus(true);

    let accountNumber: number;
    if (this.selectedAccount === undefined || this.selectedAccount === null) {
      accountNumber = 0;
    } else {
      accountNumber = this.selectedAccount;
    }

    if (this.tabIndex < 2) {
      this.subscription.add(this.cppService.cppOrderItemsList(this.filter).subscribe((result: any[]) => {
        this.draftCPPOrdersList = result.filter(x => x.successfullyProcessed === 'D');
        this.draftCPPOrdersDataSource = new MatTableDataSource(this.draftCPPOrdersList);
        this.draftCPPOrdersDataSource.paginator = this.draftCPPOrdersPaginator;
        this.draftCPPOrdersDataSource.paginator.firstPage();
        this.draftCPPOrdersDataSource.sort = this.draftCPPOrdersSort;
        this.placedCPPOrdersList = result.filter(x => x.successfullyProcessed != 'D');
        if (this.placedCPPOrdersList.length === 0) {
          this.placedCPPOrdersFooterColumns = [];
        }
        else {
          this.placedCPPOrdersFooterColumns = ['webOrderNumber', 'purchaseOrderNumber', 'accountName', 'accountNumber', 'orderCreateDate', 'status', 'contextMenu'];
        }
        const resultant = [];
        let errorCount = 0;
        let processedCount = 0;
        let unProcessedCount = 0;
        let plannedStatusCount = 0;
        let cancelledCount = 0;
        this.placedCPPOrdersList.reduce(function (res, value) {
          if (!res[value.webOrderNumber]) {
            res[value.webOrderNumber] = { ...value }; // TO CLONE
            res[value.webOrderNumber].total = 0;
            res[value.webOrderNumber].StatusList = [];
            resultant.push(res[value.webOrderNumber]);
            const outputResult = result.filter(x => x.webOrderNumber === value.webOrderNumber && x.successfullyProcessed != 'D');
            if (outputResult.filter(e => e.successfullyProcessed === 'C' && e.status === 'CANCELLED').length > 0) {
              cancelledCount += 1;
            }
            if (outputResult.filter(e => e.successfullyProcessed === 'N' || (e.successfullyProcessed === 'Y' && (e.status == 'ACCEPTED'))).length > 0) {
              unProcessedCount += 1;
            }
            if (outputResult.filter(e => (e.successfullyProcessed === 'Y' && (e.status == 'PLANNING'))).length > 0) {
              plannedStatusCount += 1;
            }
            if (outputResult.filter(e => (e.status == 'SHIPPED' || e.status == 'INVOICED')).length > 0) {
              processedCount += 1;
            }
            if (outputResult.filter(e => e.successfullyProcessed === 'E' || e.successfullyProcessed === 'B' || e.successfullyProcessed === 'F' || (e.status == 'ERROR')).length > 0) {
              errorCount += 1;
              value.status = 'ERROR';
            }
          }
          res[value.webOrderNumber].StatusList.push(value.status);
          // res[value.webOrderNumber].total += value.total;
          return res;
        }, {});
        this.errorStatusCount = errorCount;
        this.processedStatusCount = processedCount;
        this.unProcessedStatusCount = unProcessedCount;
        this.plannedStatusCount = plannedStatusCount;
        this.cancelledStatusCount = cancelledCount;
        this.placedCPPOrdersDataSource = new MatTableDataSource(resultant);
        this.placedCPPOrdersDataSource.paginator = this.placedCPPOrdersPaginator;
        this.placedCPPOrdersDataSource.paginator.firstPage();
        this.placedCPPOrdersDataSource.sort = this.placedCPPOrdersSort;
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
    else if (this.tabIndex == 2 && this.hasQuoteTabAccess == true) {
      this.subscription.add(this.quoteService.quoteOrderItemsList(this.filter).subscribe((result: any[]) => {
        this.quoteCPPOrdersAllList = result;
        this.filterDataGrid();
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
    else if ((this.hasQuoteTabAccess == true && this.tabIndex == 3) || (this.hasQuoteTabAccess == false && this.tabIndex == 2)) {
      this.filter.gridType = 'PLACED';
      this.blanketFilter = Object.assign({}, this.filter);
      this.loaderService.setLoaderStatus(false);
    }
    else if ((this.hasQuoteTabAccess == true && this.tabIndex == 4) || (this.hasQuoteTabAccess == false && this.tabIndex == 3)) {
      this.filter.gridType = 'DRAFT';
      this.blanketFilter = Object.assign({}, this.filter);
      this.loaderService.setLoaderStatus(false);
    }
  }

  filterDataGrid() {
    this.openOrderCount = this.quoteCPPOrdersAllList.filter(x => this.openStatus.includes(x.status.toUpperCase())).length;
    this.closeOrderCount = this.quoteCPPOrdersAllList.filter(x => this.closeStatus.includes(x.status.toUpperCase())).length;

    if (this.headerQuoteStatus == 1) {
      this.quoteCPPOrdersList = this.quoteCPPOrdersAllList.filter(x => this.openStatus.includes(x.status.toUpperCase()));
      this.quoteCPPOrdersInnerColumns = ['orderId', 'customerPO', 'deliverTo', 'accountId', 'draftDate', 'contextMenu'];
      this.quoteCPPOrdersColumns = ['quoteNumber', 'accountName', 'accountNumber', 'status', 'quoteDate', 'closeDate', 'preparedBy', 'preparedFor', 'openLines', 'contextMenu'];
    }
    else {
      this.quoteCPPOrdersList = this.quoteCPPOrdersAllList.filter(x => this.closeStatus.includes(x.status.toUpperCase()));
      this.quoteCPPOrdersInnerColumns = ['orderId', 'customerPO', 'deliverTo', 'accountId', 'orderDate', 'status', 'contextMenu'];
      this.quoteCPPOrdersColumns = ['quoteNumber', 'accountName', 'accountNumber', 'status', 'quoteDate', 'closeDate', 'preparedBy', 'preparedFor', 'contextMenu'];
    }

    this.quoteCPPOrdersList.forEach(x => {
      x.cppOrdersDataSource = new MatTableDataSource(x.cppOrders);
    });

    this.quoteCPPOrdersDataSource = new MatTableDataSource(this.quoteCPPOrdersList);
    this.quoteCPPOrdersDataSource.paginator = this.quoteCPPOrdersPaginator;
    this.quoteCPPOrdersDataSource.paginator.firstPage();
    this.quoteCPPOrdersDataSource.sort = this.quoteCPPOrdersSort;

    // collapse all rows
    this.quoteSortData(null);
  }

  // Create a new Cpp order(navigate to new order screen)
  createNewOrder() {
    this.cppService.setCppOrderId(0);
    this.router.navigate(['/cpp/cpp-order-create']);
  }

  // account change
  accountChange($event) {
    if ($event) {
      this.getCppOrders();
    }
  }

  // Event fired on clearing selected account from dropdown
  clearAccount() {
    this.getCppOrders();
  }

  // return sum of amount for draft orders
  getTotalDraftOrdersBalance() {
    return this.draftCPPOrdersList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  // return sum of amount for placed orders
  getTotalPlacedOrdersBalance() {
    return this.placedCPPOrdersList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  getProcessedCount() {
    return this.processedStatusCount;
  }

  getunProcessedCount() {
    return this.unProcessedStatusCount;
  }

  getErrorCount() {
    return this.errorStatusCount;
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    let accountNumber = 0;
    if (obj) {
      if (this.selectedAccount === undefined || this.selectedAccount === null) {
        accountNumber = 0;
      } else {
        accountNumber = this.selectedAccount;
      }
      this.loaderService.setLoaderStatus(true);
      this.cppService.setCppOrderId(+obj.cppOrderId);
      this.router.navigate(['/cpp/cpp-order-create']);
      this.loaderService.setLoaderStatus(false);
    }
  }

  // View Order detail and retain filters.
  viewOrderDetail(obj: any, isSplitView: boolean, tab: string) {
    if (isSplitView) {
      this.cppService.webOrderNumberAndSplitId = obj.webOrderNumber + '~' + obj.splitId + '~' + tab + '~CPPLanding';
    } else {
      this.cppService.webOrderNumberAndSplitId = obj.webOrderNumber + '~' + 0 + '~' + tab + '~CPPLanding';
    }
    // save filters in localstorage for retrieving them on navigating back.
    this.localStorageService.set('filterValueList', JSON.stringify(this.filterValueList));
    this.localStorageService.set('productFilters', JSON.stringify(this.productFilters));
    this.router.navigate(['/cpp/cpp-order-summary']);
  }

  // set the search filter list based on evolveaccountrestriction
  setSearchTypeList() {
    if (this.tabIndex < 2) {
      if (this.isEvolveAccountRestriction) {
        this.searchTypeList = ['Account', 'Product Name', 'Item Number', 'Order Date', 'Requested Arrival Date', 'Sales Order Number', 'Order ID', 'Customer PO#', 'Status'];
      }
      else {
        this.searchTypeList = ['Account Name', 'Account No', 'Product Name', 'Item Number', 'Order Date', 'Requested Arrival Date', 'Sales Order Number', 'Order ID', 'Customer PO#', 'Status'];
      }
    }
    else if (this.tabIndex == 2 && this.hasQuoteTabAccess == true) {
      if (this.isEvolveAccountRestriction) {
        this.searchTypeList = ['Account', 'Product Name', 'Item Number', 'Quote Number', 'Quote Date', 'Close Date', 'Quote Status'];
      }
      else {
        this.searchTypeList = ['Account Name', 'Account No', 'Product Name', 'Item Number', 'Quote Number', 'Quote Date', 'Close Date', 'Quote Status'];
      }
    }
    else if ((this.tabIndex === 3 && this.hasQuoteTabAccess == true) || (this.hasQuoteTabAccess == false && this.tabIndex == 2)) {
      this.searchTypeList = ['Early Advantage Order Status', 'Account Name', 'Account No', 'Product Name', 'Item Number', 'Early Advantage Order Date', 'Early Advantage Order Number', 'Customer PO#'];
    }
    else if ((this.tabIndex === 4 && this.hasQuoteTabAccess == true) || (this.hasQuoteTabAccess == false && this.tabIndex == 3)) {
      this.searchTypeList = ['Early Advantage Draft Order Status', 'Account Name', 'Account No', 'Product Name', 'Item Number', 'Early Advantage Order Date', 'Early Advantage Order Number', 'Customer PO#'];
    }

    this.selectedValue = this.searchTypeList[0];
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = {
      'ItemNo': [],
      'ProductName': null,
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'FromRequestedDeliveryDate': null,
      'ToRequestedDeliveryDate': null,
      'FromOrderDate': null,
      'ToOrderDate': null,
      'WinfieldReferenceNumber': null,
      'WebOrderNumber': null,
      'CustomerPONumber': null,
      'ProcessingStatus': null,
      'QuoteNumber': null,
      'FromQuoteDate': null,
      'ToQuoteDate': null,
      'FromCloseDate': null,
      'ToCloseDate': null,
      'Status': null,
      'BlanketOrderStatus': null,
      'BlanketOrderNumber': null,
      'FromBlanketOrderDate': null,
      'ToBlanketOrderDate': null
    };

    this.filter = {
      'itemNo': null,
      'productName': null,
      'accountName': null,
      'account': null,
      'fromRequestedDeliveryDate': null,
      'toRequestedDeliveryDate': null,
      'fromOrderDate': null,
      'toOrderDate': null,
      'winfieldReferenceNumber': null,
      'webOrderNumber': null,
      'customerPONumber': null,
      'processingStatus': null,
      'quoteNumber': null,
      'fromQuoteDate': null,
      'toQuoteDate': null,
      'fromCloseDate': null,
      'toCloseDate': null,
      'status': null,
      'blanketOrderStatus': null,
      'blanketOrderNumber': null,
      'fromBlanketOrderDate': null,
      'toBlanketOrderDate': null
    };
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.getCppOrders();
      }
      this.setAccSummaryTableHeight();
    }
  }

  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }

  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.WebOrderNumber) {
      this.productFilters.WebOrderNumber = this.validateNumText(this.productFilters.WebOrderNumber);
    }
    // if (this.productFilters.CustomerPONumber) {
    //  this.productFilters.CustomerPONumber = this.validateNumText(this.productFilters.CustomerPONumber);
    // }
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type == 'ItemNo') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'ProcessingStatus') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x + ','; });
        } else if (type == 'Status') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'BlanketOrderStatus') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x + ','; });
        } else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'Status':
          this.filter.status = selectedIds;
          break;
        case 'ProcessingStatus':
          this.filter.processingStatus = selectedIds;
          break;
        case 'BlanketOrderStatus':
          this.filter.blanketOrderStatus = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
          this.filter.productName = this.productFilters.ProductName.trim();
        }
        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strIno = '';
          this.productFilters.ItemNo.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set quote Status
        if (this.productFilters.Status && this.productFilters.Status.length > 0) {
          var strIno = '';
          this.productFilters.Status.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Quote Status : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set ProcessingStatus
        if (this.productFilters.ProcessingStatus && this.productFilters.ProcessingStatus.length > 0) {
          var strPs = '';
          this.productFilters.ProcessingStatus.forEach(x => {
            strPs = strPs + x + ', ';
          });
          this.filterValueList.push('Processing Status : ' + strPs.substr(0, strPs.length - 2));
          this.filter.processingStatus = strPs;
        }

        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo.trim();
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          // selectedIds = '';
          // this.accountList.forEach(x => {
          //  if (this.productFilters.AccountNo.indexOf(x.accountNumber) > -1) {
          //    selectedIds = selectedIds + x.accountNumber + ',';
          //  }
          // })
          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = strAct;
          }
        }
        else {
          this.filter.account = null;
        }
        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Quote Number
        if (this.productFilters.QuoteNumber && this.productFilters.QuoteNumber != '') {
          this.filterValueList.push('Quote Number : ' + this.productFilters.QuoteNumber);
          this.filter.quoteNumber = this.productFilters.QuoteNumber.trim();
        }
        else {
          this.filter.quoteNumber = null;
        }

        // Quote Status
        // if (this.productFilters.Status && this.productFilters.Status != '') {
        //   this.filterValueList.push('Quote Status : " + this.productFilters.Status);
        //   this.filter.status = this.productFilters.Status.trim();
        // }
        // else {
        //   this.filter.status = null;
        // }

        // WinField Reference Number
        if (this.productFilters.WinfieldReferenceNumber && this.productFilters.WinfieldReferenceNumber != '') {
          this.filterValueList.push('Sales Order Number : ' + this.productFilters.WinfieldReferenceNumber);
          this.filter.winfieldReferenceNumber = this.productFilters.WinfieldReferenceNumber.trim();
        }

        // Web Order Number
        if (this.productFilters.WebOrderNumber && this.productFilters.WebOrderNumber != '') {
          this.filterValueList.push('Order ID : ' + this.productFilters.WebOrderNumber);
          this.filter.webOrderNumber = this.productFilters.WebOrderNumber.trim();
        } else {
          this.filter.webOrderNumber = null;
        }

        // Customer PO#
        if (this.productFilters.CustomerPONumber && this.productFilters.CustomerPONumber != '') {
          this.filterValueList.push('Customer PO# : ' + this.productFilters.CustomerPONumber);
          this.filter.customerPONumber = this.productFilters.CustomerPONumber.trim();
        } else {
          this.filter.customerPONumber = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }

        if (this.productFilters.FromOrderDate
          && this.productFilters.FromOrderDate != null
          && this.productFilters.ToOrderDate
          && this.productFilters.ToOrderDate != null) {
          this.filterValueList.push('Order Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
          this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
        }

        if (this.productFilters.FromRequestedDeliveryDate
          && this.productFilters.FromRequestedDeliveryDate != null
          && this.productFilters.ToRequestedDeliveryDate
          && this.productFilters.ToRequestedDeliveryDate != null) {
          this.filterValueList.push('Requested Arrival Date : (' + this.datePipe.transform(this.productFilters.FromRequestedDeliveryDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToRequestedDeliveryDate, 'MM/dd/yyyy') + ')');
          this.filter.fromRequestedDeliveryDate = new Date(this.productFilters.FromRequestedDeliveryDate).toDateString();
          this.filter.toRequestedDeliveryDate = new Date(this.productFilters.ToRequestedDeliveryDate).toDateString();
        }

        if (this.productFilters.FromQuoteDate
          && this.productFilters.FromQuoteDate != null
          && this.productFilters.ToQuoteDate
          && this.productFilters.ToQuoteDate != null) {
          this.filterValueList.push('Quote Date : (' + this.datePipe.transform(this.productFilters.FromQuoteDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToQuoteDate, 'MM/dd/yyyy') + ')');
          this.filter.fromQuoteDate = new Date(this.productFilters.FromQuoteDate).toDateString();
          this.filter.toQuoteDate = new Date(this.productFilters.ToQuoteDate).toDateString();
        }

        if (this.productFilters.FromCloseDate
          && this.productFilters.FromCloseDate != null
          && this.productFilters.ToCloseDate
          && this.productFilters.ToCloseDate != null) {
          this.filterValueList.push('Close Date : (' + this.datePipe.transform(this.productFilters.FromCloseDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToCloseDate, 'MM/dd/yyyy') + ')');
          this.filter.fromCloseDate = new Date(this.productFilters.FromCloseDate).toDateString();
          this.filter.toCloseDate = new Date(this.productFilters.ToCloseDate).toDateString();
        }

        // Set BlanketOrderStatus
        if (this.productFilters.BlanketOrderStatus && this.productFilters.BlanketOrderStatus.length > 0) {
          var strPs = '';
          this.productFilters.BlanketOrderStatus.forEach(x => {
            strPs = strPs + x + ', ';
          });
          this.filterValueList.push('Early Advantage Order Status : ' + strPs.substr(0, strPs.length - 2));
        }

        // Early Advantage Order Number
        if (this.productFilters.BlanketOrderNumber && this.productFilters.BlanketOrderNumber != '') {
          this.filterValueList.push('Early Advantage Order Number : ' + this.productFilters.BlanketOrderNumber);
          this.filter.blanketOrderNumber = this.productFilters.BlanketOrderNumber.trim();
        } else {
          this.filter.blanketOrderNumber = null;
        }

        // Early Advantage Order Date
        if (this.productFilters.FromBlanketOrderDate
          && this.productFilters.FromBlanketOrderDate != null
          && this.productFilters.ToBlanketOrderDate
          && this.productFilters.ToBlanketOrderDate != null) {
          this.filterValueList.push('Early Advantage Order Date : (' + this.datePipe.transform(this.productFilters.FromBlanketOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToBlanketOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromBlanketOrderDate = new Date(this.productFilters.FromBlanketOrderDate).toDateString();
          this.filter.toBlanketOrderDate = new Date(this.productFilters.ToBlanketOrderDate).toDateString();
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;

      case 'Product Name':
        this.productFilters.ProductName = null;
        this.filter.productName = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Sales Order Number':
        this.productFilters.WinfieldReferenceNumber = null;
        this.filter.winfieldReferenceNumber = null;
        break;
      case 'Order ID':
        this.productFilters.WebOrderNumber = null;
        this.filter.webOrderNumber = null;
        break;
      case 'Customer PO#':
        this.productFilters.CustomerPONumber = null;
        this.filter.customerPONumber = null;
        break;
      case 'Requested Arrival Date':
        this.productFilters.FromRequestedDeliveryDate = null;
        this.productFilters.ToRequestedDeliveryDate = null;
        this.filter.fromRequestedDeliveryDate = null;
        this.filter.toRequestedDeliveryDate = null;
        this.fromRequestedDeliveryDateFilter = '';
        this.toRequestedDeliveryDateFilter = '';
        break;
      case 'Order Date':
        this.productFilters.FromOrderDate = null;
        this.productFilters.ToOrderDate = null;
        this.filter.fromOrderDate = null;
        this.filter.toOrderDate = null;
        this.fromOrderDateFilter = '';
        this.toOrderDateFilter = '';
        break;
      case 'Processing Status':
        this.productFilters.ProcessingStatus = null;
        this.filter.processingStatus = null;
        break;
      case 'Quote Status':
        this.productFilters.Status = null;
        this.filter.status = null;
        break;
      case 'Quote Number':
        this.productFilters.QuoteNumber = null;
        this.filter.quoteNumber = null;
        break;
      case 'Early Advantage Order Status':
        this.productFilters.BlanketOrderStatus = null;
        this.filter.blanketOrderStatus = null;
        break;
      case 'Early Advantage Order Number':
        this.productFilters.BlanketOrderNumber = null;
        this.filter.blanketOrderNumber = null;
        break;
      case 'Early Advantage Order Date':
        this.productFilters.FromBlanketOrderDate = null;
        this.productFilters.ToBlanketOrderDate = null;
        this.filter.fromBlanketOrderDate = null;
        this.filter.toBlanketOrderDate = null;
        this.fromBlanketOrderDateFilter = '';
        this.toBlanketOrderDateFilter = '';
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();

    this.resetPageFilter();
    this.validateRequestedDeliveryDateFilter('clearAll', '');
    this.validateOrderDateFilter('clearAll', '');
    this.getCppOrders();
    this.setAccSummaryTableHeight();
  }

  // validate the Scheduled Delivery Date filter on search filters
  validateRequestedDeliveryDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromRequestedDeliveryDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToRequestedDeliveryDate) {
        var toDate = new Date(this.productFilters.ToRequestedDeliveryDate);
        this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toRequestedDeliveryDate') {
      toDate = new Date($event.value);
      this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromRequestedDeliveryDate) {
        var fromDate = new Date(this.productFilters.FromRequestedDeliveryDate);
        this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromRequestedDeliveryDateFilter = '';
      this.toRequestedDeliveryDateFilter = '';
    }
  }

  // validate the Early Advantage Order Date filter on search filters
  validateBlanketOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromBlanketOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToBlanketOrderDate) {
        var toDate = new Date(this.productFilters.ToBlanketOrderDate);
        this.fromBlanketOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toBlanketOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toBlanketOrderDate') {
      toDate = new Date($event.value);
      this.fromBlanketOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromBlanketOrderDate) {
        var fromDate = new Date(this.productFilters.FromBlanketOrderDate);
        this.toBlanketOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromBlanketOrderDateFilter = '';
      this.toBlanketOrderDateFilter = '';
    }
  }

  // validate the order date filter on search filters
  validateOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToOrderDate) {
        var toDate = new Date(this.productFilters.ToOrderDate);
        this.fromOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toOrderDate') {
      toDate = new Date($event.value);
      this.fromOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromOrderDate) {
        var fromDate = new Date(this.productFilters.FromOrderDate);
        this.toOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromOrderDateFilter = '';
      this.toOrderDateFilter = '';
    }
  }

  // validate the Quote date filter on search filters
  validateQuoteDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromQuoteDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToQuoteDate) {
        var toDate = new Date(this.productFilters.ToQuoteDate);
        this.fromQuoteDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toQuoteDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toQuoteDate') {
      toDate = new Date($event.value);
      this.fromQuoteDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromQuoteDate) {
        var fromDate = new Date(this.productFilters.FromQuoteDate);
        this.toQuoteDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromQuoteDateFilter = '';
      this.toQuoteDateFilter = '';
    }
  }

  // validate the close date filter on search filters
  validateCloseDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromCloseDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToCloseDate) {
        var toDate = new Date(this.productFilters.ToCloseDate);
        this.fromCloseDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toCloseDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toCloseDate') {
      toDate = new Date($event.value);
      this.fromCloseDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromCloseDate) {
        var fromDate = new Date(this.productFilters.FromCloseDate);
        this.toCloseDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromCloseDateFilter = '';
      this.toCloseDateFilter = '';
    }
  }

  // Email order detail
  emailOrderDetail(obj: any) {
    this.tabNode = this.tabNode ? false : true;
    const data = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: obj.emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: data
    });

    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          WebOrderNumber: obj.webOrderNumber,
          EmailIds: emailIds
        };
        this.subscription.add(this.cppService.sendCPPOrderConfirmationEmail(data).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
        }));
      }
      this.tabNode = false;
    }));
  }

  // Delete a draft order
  deleteOrder(order: any) {
    if (order) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Order', message: 'Do you want to delete this saved order?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.cppService.deleteCppOrder(order.cppOrderId).subscribe(result => {
            if (result) {
              this.getCppOrders();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      }));
    }
  }

  // Generate Pdf report
  generatePdf(order: any) {
    if (order.webOrderNumber) {
      this.loaderService.setLoaderStatus(true);
      const self = this;
      this.subscription.add(this.cppService.getOrderSummaryDetails(order.webOrderNumber).subscribe((result: CPPOrderSummaryVM) => {
        if (result) {
          if (result !== undefined && result.splitDetails.length > 0) {
            this.cppProductItemsDataSource2 = result.splitDetails;
            this.cppProductItemsDataSource2.forEach(x => {
              x.productDetail.forEach(prod => {
                if (prod.bulkPackaged == 'bulk' || prod.bulkPackaged == 'BULK') {
                  this.isBulkItemAvailable = true;
                }
                else if (prod.bulkPackaged == "packaged" || prod.bulkPackaged == "PACKAGED") {
                  this.isPackagedItemAvailable = true;
                }
              });
            });
            self.orderPdf = result;
            this.pdfDataObject = result;
            this.totalNumbersOfOrder = result.splitDetails.length;
            result.splitDetails.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
            const documentDefinition = this.getDocumentDefinition();
            if (this.isInMobileApp) {
              const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
              pdfDocGenerator.getBase64((data) => {
                this.basePdfData = data;
                const currentDateTime = new Date();
                this.filter2 = {
                  MobilePDFBase64: this.basePdfData,
                  FileName: 'CPPOrder_' + order.webOrderNumber + '_' + currentDateTime.getDate() + (currentDateTime.getMonth() + 1) + currentDateTime.getFullYear() + '_' + currentDateTime.getHours() + currentDateTime.getMinutes() + currentDateTime.getSeconds() + '.pdf'
                };
                this.subscription.add(this.cppService.sendBaseDate(this.filter2).subscribe((result) => {
                  this.loaderService.setLoaderStatus(false);
                }, error => this.loaderService.setLoaderStatus(false)));
              });
            }
            else {
              pdfMake.createPdf(documentDefinition).download('CPP_Order_' + order.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
            }
          } else {
            this.toastrService.error('No data available for WebOrderNumber #' + order.webOrderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  // Get the details filled for variables above and below the table in PDF
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    // const orderCreateDate = new Date(this.pdfDataObject.createdOn);
    const orderCreateDate = this.pdfDataObject.createdOnString;

    if (this.pdfDataObject.deliverToDetail) {
      this.deliverToAccountdetails.AccountNumber = this.pdfDataObject.deliverToDetail.accountNo;
      this.deliverToAccountdetails.AccountName = this.pdfDataObject.deliverToDetail.accountName;
      this.deliverToAccountdetails.Address1 = this.pdfDataObject.deliverToDetail.address1;
      this.deliverToAccountdetails.AccountCity = this.pdfDataObject.deliverToDetail.city;
      this.deliverToAccountdetails.AccountState = this.pdfDataObject.deliverToDetail.state;
      this.deliverToAccountdetails.AccountZipCode = this.pdfDataObject.deliverToDetail.zipCode;
    }

    // this.soldToAccountdetails
    if (this.pdfDataObject.soldToDetail) {
      this.soldToAccountdetails.AccountNumber = this.pdfDataObject.soldToDetail.accountNo;
      this.soldToAccountdetails.AccountName = this.pdfDataObject.soldToDetail.accountName;
      this.soldToAccountdetails.Address1 = this.pdfDataObject.soldToDetail.address1;
      this.soldToAccountdetails.Address2 = this.pdfDataObject.soldToDetail.address2.replace('<br>', '');
      this.soldToAccountdetails.AccountCity = this.pdfDataObject.soldToDetail.city;
      this.soldToAccountdetails.AccountState = this.pdfDataObject.soldToDetail.state;
      this.soldToAccountdetails.AccountZipCode = this.pdfDataObject.soldToDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }

    if (this.isBulkItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, 'MM/dd/yyyy')],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber]
        ]
      };
    }
    else {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, 'MM/dd/yyyy')],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber]
        ]
      };
    }

    if (this.isPackagedItemAvailable) {
      if (this.pdfDataObject.packagedContactName) bulkdetailsheader.body.push(['CONTACT NAME:', this.pdfDataObject.packagedContactName]);
      if (this.pdfDataObject.packagedContactNumber) bulkdetailsheader.body.push(['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber]);
      if (this.pdfDataObject.packagedDeliveryInst) bulkdetailsheader.body.push(['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst]);
    }

    this.isBulkItemAvailable = false;

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.disclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          margin: [40, 5, 40, 0] 
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.dynamicDisclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          widths: ['*'],
          margin: [40, 0, 40, 0] 
        },
        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + ' (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343.'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#FDCF35',
          color: '#0b3f54'
        },
        tablePayment: {
          fontSize: 8,
          background: '#6fc8c0',
          color: '#0b3f54'
        }
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    const tblObject = [];
    splitDetails.forEach(obj => {
      let jdeNumber = '';
      if (obj.jdeorderNumber) {
        jdeNumber = obj.jdeorderNumber;
      }
      const cppOrderDetails = obj.productDetail;
      const desDelDate = (obj.productDetail[0].desiredDeliveryDate == null || obj.productDetail[0].desiredDeliveryDate == undefined) ? '' : obj.productDetail[0].desiredDeliveryDate;
      const desiredDeliveryDate = (desDelDate === '' ? '' : this.datePipe.transform(desDelDate.toString(), 'MM/dd/yyyy'));
      if (jdeNumber != '') {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Sales Order #: ' + jdeNumber,
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }
      else {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['25%', '25%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }

      const tbl = {
        table: {
          widths: ['55%', '15%', '15%', '15%'], // , '10%', '10%', '10%', '15%'
          color: '#0b3f54',
          body: [
            [{
              text: 'Product',
              style: 'tableHeader'
            },
            {
              text: 'Ordered Quantity',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Ordering UOM',
              style: 'tableHeader', alignment: 'center'
            },
            {
                text: 'Total',
                style: 'tableHeader', alignment: 'center'
            }],
            ...cppOrderDetails.map(cpp => {
              var cellData = [],
                cellData = this.cppModifiedCellData(cpp);
              return [
                { text: cellData },
                { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                { text: cpp.uom, alignment: 'center' },
                { text: cpp.totalGallons, alignment: 'center' }];
            })
          ]
        },
        style: 'tablefont',
      };
      tblObject.push(tbl);
    });

    return tblObject;
  }

  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    if (cpp.yourPrice != null && cpp.yourPrice != '' && cpp.yourPrice != undefined && cpp.yourPrice != 0) {
      tempArray.push({
        text: ('$' + cpp.yourPrice.toFixed(4) + '/' + cpp.pricingUOM + '\n'), style: 'tableUnit'
      });
    }
    if (cpp.paymentTerms != null && cpp.paymentTerms != '' && cpp.paymentTerms != undefined) {
      tempArray.push({
        text: (cpp.paymentTerms.trim()), style: 'tablePayment'
      });
    }

    return tempArray;
  }

  // Trim the instruction details text if text length > 10
  getInstructionDetails(item) {
    const details = item.length > 10 ? item.substr(0, 10) + '....' : item;
    return details;
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
  }

  // Get Cpp orders report
  getExcelReport() {
    if (this.tabIndex < 2) {
      this.loaderService.setLoaderStatus(true);

      this.subscription.add(this.cppService.getCPPReport(this.filter).subscribe((result: any[]) => {
        const exportData = [];
        if (result && result.length > 0) {
          this.loaderService.setLoaderStatus(true);
          result.forEach(x => {
            exportData.push({
              'Order ID': x.webOrderNumber + (((+x.splitId >= 100) || (+x.splitId === 1)) ? ('-' + x.splitId) : ''),
              'Customer PO#': x.purchaseOrderNumber,
              'Account Name': x.accountName,
              'Account#': x.accountNumber,
              'Order Date': this.datePipe.transform(x.orderDate, 'MM/dd/yyyy'),
              'Product': x.productName,
              'Quantity': x.quantity + (x.uom ? ' ' + x.uom : ''),
              'Status': x.status,
              'Bulk Contact Name': x.bulkContactName,
              'Bulk Contact Number': x.bulkContactPhoneNumber,
            });
          });
          this.excelService.exportAsExcelFile(exportData, 'Crop Protection Orders');
          this.loaderService.setLoaderStatus(false);
        } else {
          this.toastrService.error('No placed orders available for current user');
          this.loaderService.setLoaderStatus(false);
        }
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
    else if (this.tabIndex == 2 && this.hasQuoteTabAccess == true) {
      this.loaderService.setLoaderStatus(true);

      this.subscription.add(this.quoteService.quoteOrderItemsListExport(this.filter).subscribe((result: any[]) => {
        if (result && result.length > 0) {
          const exportData = [];
          result.forEach(x => {
            if ((this.headerQuoteStatus == 1 && this.openStatus.some(o => o == x.status.toUpperCase()))
              || (this.headerQuoteStatus == 2 && this.closeStatus.some(o => o == x.status.toUpperCase()))) {
              exportData.push({
                'Quote Number': x.quoteNumber,
                'Quote Type': x.quoteType,
                'Account Number': x.accountNumber,
                'Account Name': x.accountName,
                'Account Address': x.accountAddress1,
                'Account City': x.accountCity,
                'Account State/Province': x.accountState,
                'Account Postal Code': x.accountZipCode,
                'Quote Date': this.datePipe.transform(x.quoteDate, 'MM/dd/yyyy'),
                'Close Date': this.datePipe.transform(x.closeDate, 'MM/dd/yyyy'),
                'Prepared By': x.preparedByName,
                'WU Approver': x.quoteApprovedByName,
                'Prepared For': x.preparedForName,
                'Status': x.status,
                'Comments': x.comments,
                'Approved By': x.approvedByUserID,
                'Approval Date': (x.approvedByUserID == null || x.approvedByUserID === '') ? '' : this.datePipe.transform(x.approvalDate, 'MM/dd/yyyy'),
                'Item Number': x.itemNumber,
                'Vendor Name': x.itemVendorName,
                'Item Description': x.itemDescription,
                'Quote Quantity - Ordering UOM': x.quantityShipping,
                'Ordering UOM': x.unitofMeasureShipping,
                'Quote Price - Ordering UOM': this.isCPPPriceAccess ? x.orderUOM.toFixed(4) : '',
                'Quote Quantity - Pricing UOM': x.quantityPricing.toFixed(4),
                'Pricing UOM': x.unitofMeasurePricing,
                'Quote Price - Pricing UOM': this.isCPPPriceAccess ? x.unitPrice.toFixed(4) : '',
                'Discount from National Price': this.isCPPPriceAccess ? x.priceQuantityConversion.toFixed(4) : '',
                'Requested Ship Date': this.datePipe.transform(x.requestedDate, 'MM/dd/yyyy'),
                'Payment Terms Description': x.paymentTermsDescription
              });
            }
          });
          this.excelService.exportAsExcelFile(exportData, 'Crop Protection Quotes');
        }
        else {
          this.toastrService.error('No quote orders available for current user');
          this.loaderService.setLoaderStatus(false);
        }
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
    else if (this.tabIndex == 3 || this.tabIndex == 4 || (this.hasQuoteTabAccess == false && this.tabIndex == 3) || (this.hasQuoteTabAccess == false && this.tabIndex == 2)) {
      this.loaderService.setLoaderStatus(true);
      const zeroRemainingQty = 0;
      const excelName = this.filter.gridType == 'PLACED' ? 'Early Advantage Order' : 'Early Advantage Draft Order';
      const errorMsg = this.filter.gridType == 'PLACED' ? 'No Early Advantage Orders available for current user' : 'No Early Advantage Draft Orders available for current user';

      this.subscription.add(this.blanketOrderService.blanetOrderExportList(this.filter).subscribe((result: any[]) => {
        if (result && result.length > 0) {
          const exportData = [];
          result.forEach(x => {
            exportData.push({
              'Company': x.companyName,
              'Early Advantage Order Date': this.datePipe.transform(x.blanketOrderDate, 'MM/dd/yyyy'),
              'Early Advantage Order Close Date': this.datePipe.transform(x.blanketOrderCloseDate, 'MM/dd/yyyy'),
              'Early Advantage Order Number': x.blanketOrderNumber,
              'Early Advantage Order Line Status': x.blanketOrderLineStatus,
              'Sold To Account Number': x.soldToAccountNumber,
              'Sold To Name': x.soldToName,
              'Sold To Address': x.soldToAddress1,
              'Sold To City': x.soldToCity,
              'Sold To State': x.soldToState,
              'Sold To Zip Code': x.soldToZipCode,
              'Ship To Account Number': x.shipToAccountNumber,
              'Ship To Name': x.shipToName,
              'Ship To Address': x.shipToAddress1,
              'Ship To City': x.shipToCity,
              'Ship To State': x.shipToState,
              'Ship To Zip Code': x.shipToZipCode,
              'PO # ': x.customerPONumber,
              'Product Code': x.productCode,
              'Product': x.product,
              'Order QTY': x.orderQty.toFixed(4),
              'Order UOM': x.orderUom,
              'Shipped Qty': x.shipToQty.toFixed(4),
              'Remaining QTY': x.remainingQty > 0 ? x.remainingQty.toFixed(4) : zeroRemainingQty.toFixed(4),
              'Package Size': x.packageSize,
              'Bulk Contact Name': x.bulkOrPackaged.toLowerCase() == 'bulk' ? x.bulkContactName : ' ',
              'Bulk Contact Number': x.bulkOrPackaged.toLowerCase() == 'bulk' ? x.bulkContactNumber : ' ',
              'Requested Date': x.bulkOrPackaged.toLowerCase() == 'bulk' ? this.datePipe.transform(x.requestedDeliveryDate, 'MM/dd/yyyy') : ' '
            });
          });
          this.excelService.exportAsExcelFile(exportData, excelName);
        }
        else {
          this.toastrService.error(errorMsg);
          this.loaderService.setLoaderStatus(false);
        }
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); }));
    }
  }

  getStatusText(value) {
    return this.quoteStatusList.find(x => x.value.toUpperCase() == value.toUpperCase()).text;
  }

  viewQuoteDetails(element) {
    this.router.navigate(['/quote/view-quote-details/' + element.quoteNumber]);
  }

  viewQuoteOrders(quoteElement) {
    this.quoteService.setQuoteId(quoteElement.quoteId);
    this.router.navigate(['/quote/view-quote-order']);
  }

  // reset expanded grid
  quoteSortData(sort) {
    if (this.quoteCPPOrdersDataSource.data && this.quoteCPPOrdersDataSource.data.length > 0) {
      this.quoteCPPOrdersDataSource.filteredData = this.quoteCPPOrdersDataSource.filteredData.map(c => {
        c.isExpanded = false;
        return c;
      });
    }
  }

  // redirect to edit order
  editQuoteOrder(quoteId, cppOrderId) {
    this.quoteService.setQuoteId(quoteId);
    this.quoteService.setCppOrderId(cppOrderId);
    this.router.navigate(['/quote/create-quote-order']);
  }

  viewQuoteConsolidatedOrder(quoteElement) {
    this.quoteService.setQuoteId(quoteElement.quoteId);
    this.router.navigate(['/quote/quote-order-summary']);
  }

  viewQuoteOrder(quoteElement) {
    this.quoteService.setQuoteId(quoteElement.quoteId);
    this.quoteService.setCppOrderId(quoteElement.cppOrderId);
    this.router.navigate(['/quote/quote-order-summary']);
  }

  // Email order detail
  emailQuoteOrder(obj: any, isAll: boolean = true) {
    this.tabNode = this.tabNode ? false : true;
    const data = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: obj.email, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: data
    });
    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          QuoteId: obj.quoteId,
          CPPOrderId: isAll ? 0 : obj.cppOrderId,
          EmailIds: emailIds
        };
        this.subscription.add(this.quoteService.sendQuoteOrderConfirmationEmail(data).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
        }));
      }
      this.tabNode = false;
    }));
  }

  // Generate Pdf report
  generateQuotePdf(quoteElement: any, isAll: boolean = true) {
    this.loaderService.setLoaderStatus(true);
    const quoteId = quoteElement.quoteId;
    const cppOrderId = isAll ? 0 : quoteElement.cppOrderId;
    this.subscription.add(this.quoteService.getQuoteOrderSummary(quoteId, cppOrderId).subscribe((result) => {
      this.quoteService.generatePdf(result, this.isCPPPriceAccess);
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  generatePdfUrl(quoteElement: any, isAll: boolean = true) {
    this.isTestPdf = true;
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppService.sendBaseDate(this.filter2).subscribe((result: any[]) => {
      if (result) {
        this.baseApisuccess = true;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));

    if (this.baseApisuccess) {
      this.subscription.add(this.quoteService.getNewTestPdf().subscribe((result) => {
        window.open(result.filePath, '_blank');
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  createNewBlanketOrder() {
    this.router.navigate(['/cpp/blanket-order-create']);
  }

  // Get cpp orders with retained filters when returning from cpp order summary screen.
  GetCppOrdersByRetainedFilters() {
    const productFilters = this.localStorageService.get('productFilters');
    const filterValueList = this.localStorageService.get('filterValueList');

    if (filterValueList && productFilters) {
      this.filterValueList = JSON.parse(filterValueList);
      this.productFilters = JSON.parse(productFilters);
      this.retainFilter(null, ' ');

      // remove filters from localstorage once filters are applied.
      // if navigation on cpp order summary screen
      // then filters will be saved again using viewOrderDetail()
      // else there's no need to retain filter.
      this.localStorageService.remove('productFilters');
      this.localStorageService.remove('filterValueList');
    }
  }

  setBlanketOrderGridCount(data) {
    this.blanketOrdersDataSource = new MatTableDataSource(data);
  }

  setBlanketDraftOrderGridCount(data) {
    this.blanketDraftOrdersDateSource = new MatTableDataSource(data);
  }

  showNewEarlyAdvantageRequestBtn(): boolean {
    let isShow = false;
    if (!this.readOnlyAccess && (this.tabIndex === 3 || this.tabIndex === 4 || (this.hasQuoteTabAccess == false && this.tabIndex == 2) || (this.hasQuoteTabAccess == false && this.tabIndex == 3))) {
      isShow = true;
    }
    return isShow;
  }
  getSeasonBanner() {
    this.subscription.add(this.commonService.getSeasonBannerUrl('cpp').subscribe(result => {
        this.haveBannerMessage = result.haveBannerMessage;
    }, error => LolLoggerService.error(error)));
  }

  GetDisclaimerMessage() {
    this.subscription.add(this.cppService.GetDisclaimerMessage().subscribe((result: any) => {
      if (result) {
        this.dynamicDisclaimerMessage = result.message;
      }
    }, error => LolLoggerService.error(error)));
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.commonService.currentTabIndex.next(0);
      this.subscription.unsubscribe();
    }
  }
}
